import { render, staticRenderFns } from "./ModalAgrupador.vue?vue&type=template&id=34d246b7"
import script from "./ModalAgrupador.vue?vue&type=script&lang=js"
export * from "./ModalAgrupador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports